import { Container, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import CustomLinearProgress from './custom-linear-progress';

const QuestionnaireComplete: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <CustomLinearProgress value={100} />
      <Container maxWidth={'lg'}>
        <Stack gap={4}>
          <Typography className={classes.title}>{t('leadQuestionnaireSurveyFinished')}</Typography>
          <Stack gap={2}>
            <Paper className={classes.textContainer} elevation={2} square={true}>
              <Stack gap={2}>
                <Typography className={classes.text} align={'center'}>
                  {t('leadQuestionnaireSurveyFinishedText1')}
                </Typography>
                <Typography className={classes.text} align={'center'}>
                  {t('leadQuestionnaireSurveyFinishedText2')}
                </Typography>
              </Stack>
            </Paper>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(32),
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '24px',
  },
  textContainer: {
    padding: '24px 32px',
    background: 'rgba(0,0,0,0.03)',
  },
  text: {
    fontSize: theme.typography.pxToRem(18),
  },
}));

export default QuestionnaireComplete;
